import React from 'react';
import { Instagram, Facebook, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t-4 border-rosegold pt-16 pb-8" data-id="element-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-25">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-26">
          {/* Col 1 */}
          <div data-id="element-27">
            <a href="#" className="flex flex-col mb-6 inline-block" data-id="element-28">
              <span className="font-serif text-2xl tracking-wide text-charcoal leading-none" data-id="element-29">
                MANTRA
              </span>
              <span className="font-sans text-[10px] tracking-[0.2em] text-charcoal/70 uppercase mt-1" data-id="element-30">
                Medicina Estética
              </span>
            </a>
            <p className="text-charcoal/60 text-sm leading-relaxed max-w-xs" data-id="element-31">
              Medicina estética avanzada diseñada por médicas especializadas
              para resultados naturales, seguros y duraderos.
            </p>
          </div>

          {/* Col 2 */}
          <div data-id="element-32">
            <h4 className="font-serif font-semibold text-charcoal mb-6" data-id="element-33">
              Enlaces Rápidos
            </h4>
            <ul className="space-y-4" data-id="element-34">
              <li data-id="element-35">
                <a href="#tratamientos" className="text-charcoal/60 hover:text-rosegold text-sm transition-colors" data-id="element-36">
                  Tratamientos
                </a>
              </li>
              <li data-id="element-37">
                <a href="#nosotros" className="text-charcoal/60 hover:text-rosegold text-sm transition-colors" data-id="element-38">
                  Quiénes Somos
                </a>
              </li>
              <li data-id="element-39">
                <a href="#" className="text-charcoal/60 hover:text-rosegold text-sm transition-colors" data-id="element-40">
                  Blog Médico
                </a>
              </li>
              <li data-id="element-41">
                <a href="#reservar" className="text-charcoal/60 hover:text-rosegold text-sm transition-colors" data-id="element-42">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Col 3 */}
          <div data-id="element-43">
            <h4 className="font-serif font-semibold text-charcoal mb-6" data-id="element-44">
              Conectemos
            </h4>
            <div className="flex gap-4 mb-6" data-id="element-45">
              <a href="#" className="w-10 h-10 rounded-full bg-ivory flex items-center justify-center text-charcoal hover:bg-rosegold hover:text-white transition-colors" data-id="element-46">
                <Instagram size={18} data-id="element-47" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-ivory flex items-center justify-center text-charcoal hover:bg-rosegold hover:text-white transition-colors" data-id="element-48">
                <Facebook size={18} data-id="element-49" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-ivory flex items-center justify-center text-charcoal hover:bg-rosegold hover:text-white transition-colors" data-id="element-50">
                <Mail size={18} data-id="element-51" />
              </a>
            </div>
            <address className="not-italic text-charcoal/60 text-sm" data-id="element-52">
              Buxareo 1185
              <br data-id="element-53" />
              Montevideo, Uruguay
            </address>
          </div>
        </div>

        <div className="border-t border-charcoal/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-54">
          <p className="text-charcoal/40 text-xs" data-id="element-55">
            © 2025 Mantra Medicina Estética — Todos los derechos reservados
          </p>
          <div className="flex gap-4 text-xs text-charcoal/40" data-id="element-56">
            <a href="#" className="hover:text-rosegold transition-colors" data-id="element-57">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-rosegold transition-colors" data-id="element-58">
              Política de Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}